module.exports = __webpack_public_path__ + "img/1704ff2.png";